<template>
  <DKTeaser :teaser="teaser" :backgroundColor="fragment.background"></DKTeaser>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { DKTeaserFragment as DKTeaserFragmentModel } from '@/models/DKTeaserFragment';
import { DKTeaser } from '@dormakaba/dormakaba-components';
import { Teaser as TeaserModel } from '@/models/Teaser';
import { TeaserStyleType } from '@/models/TeaserStyleType';

@Component({
  components: {
    DKTeaser,
  },
})
export default class DKTeaserFragment extends Vue {
  @Prop() fragment!: DKTeaserFragmentModel;

  get teaser(): TeaserModel {
    return {
      shortTitle: this.fragment?.shortTitle ?? '',
      preTitle: this.fragment?.preTitle,
      style: this.fragment?.style as TeaserStyleType,
      title: this.fragment?.title,
      image: this.fragment?.image,
      description: this.fragment?.description ?? '',
      links: this.fragment?.linkResources,
      assets: this.fragment?.assetResources,
      orientation: this.fragment?.orientation,
    };
  }
}
</script>
